export default {"src":"/_next/static/media/equipment.86590c44.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};